import type { ActionFunction } from '@remix-run/node';
import { json } from '@remix-run/node';
import invariant from 'tiny-invariant';
import type {
    CreateCommentMutation,
    CreateCommentMutationVariables,
} from 'generated/graphql';
import { CreateCommentDocument } from 'generated/graphql';

export const CREATE_BUILD_HUB_COMMENT_API_ROUTE =
    '/remix-api/app/build-hub-comment-create';

const DEFAULT_FAILED_MESSAGE = 'Failed to create BuildHub comment.';

/**
 * Action to comment on a target item.
 */
export const action: ActionFunction = async ({ request, context }) => {
    const data = await request.formData();

    invariant(data.get('targetId'), 'No Comment Target ID submitted for update.');
    invariant(data.get('message'), 'No Comment Message submitted for update.');

    const variables: CreateCommentMutationVariables = {
        Message: data.get('message') as string,
        CommentTargetID: data.get('targetId') as string,
    };

    const mentions = data.getAll('mentionIds').map((m) => String(m));
    if (mentions) {
        variables.Mentions = mentions;
    }

    const files = data.getAll('fileIds').map((f) => String(f));
    if (files) {
        variables.Files = files;
    }

    try {
        const { data: result } = await context.client.mutate<
            CreateCommentMutation,
            CreateCommentMutationVariables
        >({
            mutation: CreateCommentDocument,
            variables,
        });

        const validResult = result?.commentSubmit;
        if (!validResult) {
            return json({
                buildHubUpsert: {
                    __typename: 'ServerError',
                    Message: DEFAULT_FAILED_MESSAGE,
                },
            });
        }

        return json(result);
    } catch (error) {
        return json({
            buildHubUpsert: {
                __typename: 'ServerError',
                Message:
                    error instanceof Error
                        ? error.message
                        : DEFAULT_FAILED_MESSAGE,
            },
        });
    }
};
